<p class="mr-2">{{ row?.firstName }} {{ row?.lastName }}</p>
